import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import './scss/style.scss'
import i18n from './i18n'
import { boot } from '@/bootstrap/app-bootstrap'

Vue.config.productionTip = false

import Plugin from '@quasar/quasar-ui-qcalendar'
import '@quasar/quasar-ui-qcalendar/dist/index.css'

Vue.use(Plugin)

boot().then(() => {
    new Vue({
        router,
        store,
        i18n,
        render: (h) => h(App),
    }).$mount('#app')
})
